// import { canUseDOM } from 'exenv';

export function innovationByDesignPageLoading(resp = {}, store = {}) {
  return {
    type: 'INNOVATION_BY_DESIGN_PAGE_LOADING',
    innovationByDesignPage: resp,
    store
  };
}

export function innovationByDesignPageLoaded(resp = {}, store = {}) {
  return {
    type: 'INNOVATION_BY_DESIGN_PAGE_LOADED',
    innovationByDesignPage: resp,
    store
  };
}

export function innovationByDesignPageLoadError(error, store = {}) {
  return {
    type: 'INNOVATION_BY_DESIGN_PAGE_ERROR',
    innovationByDesignPage: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store
  };
}
